import "office-ui-fabric-react/dist/css/fabric.min.css";
import App from "./app/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "office-ui-fabric-react/lib/Icons";
import * as React from "react";
import * as ReactDOM from "react-dom";
/* global AppContainer, Component, document, Office, module, React, require */

initializeIcons();

let isOfficeInitialized = false;

const title = "TRIYO Add-in";

const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <Component title={title} isOfficeInitialized={isOfficeInitialized} />
    </AppContainer>,
    document.getElementById("container")
  );
};

/* Render application after Office initializes */
Office.initialize = () => {
  isOfficeInitialized = true;
  render(App);
};

if (module.hot) {
  module.hot.accept("./app/App", () => {
    const NextApp = require("./app/App").default;
    render(NextApp);
  });
}
